import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_ADMIN_CATEGORIES = createRequestTypes('GET_ADMIN_CATEGORIES');
export const getCategories = {
  request: data => action(GET_ADMIN_CATEGORIES[REQUEST], data),
  success: data => action(GET_ADMIN_CATEGORIES[SUCCESS], { data }),
  failure: error => action(GET_ADMIN_CATEGORIES[FAILURE], { error }),
};

export const GET_ADMIN_QUESTIONS = createRequestTypes('GET_ADMIN_QUESTIONS');
export const getQuestions = {
  request: categoryId => action(GET_ADMIN_QUESTIONS[REQUEST], { categoryId }),
  success: data => action(GET_ADMIN_QUESTIONS[SUCCESS], { data }),
  failure: error => action(GET_ADMIN_QUESTIONS[FAILURE], { error }),
};
